// @flow
import React from "react"
import { withStateHandlers, type HOC } from "recompose"
import ModalBody from "modals/_Body"
import ModalHeader from "modals/_Header"
import ForgotPasswordForm from "./ForgotPasswordForm"
import Success from "./Success"

const ForgotPasswordModal = ({ emailSent, setEmailSent, close }) => (
  <ModalBody close={close}>
    <ModalHeader close={close} title="Forgot password" />
    {emailSent ? (
      <Success close={close} />
    ) : (
      <ForgotPasswordForm setEmailSent={setEmailSent} />
    )}
  </ModalBody>
)

type Outter = {|
  close: Function,
|}

const enhancer: HOC<*, Outter> = withStateHandlers(
  { emailSent: false },
  { setEmailSent: () => v => ({ emailSent: v }) },
)

export default enhancer(ForgotPasswordModal)



// WEBPACK FOOTER //
// ./src/modals/ForgotPassword/index.js